<template>
   <span class="">{{minutosPasados}} </span>
</template>

<script>
export default {
  name: "CiudadanoRow",
  props: {
    msg: String,
    hora:Number,
    estatus:String,
    keyCiudadano: String,
    
  },
  data() {
    return {
      reloj: null,
      fechaCreacion:null,
      minutosPasados:null,
      momentFechaCreacion:null,
      laReferencia:false,
      MinutesLimit:2,
      minutos:0,
      segundos:0
    };
  },
  methods:{
    beginsTimer(){
      var self = this;
      this.minutosPasados = "calculando ..."
      this.interval = setInterval(()=>{
        this.cronometro();
      },1000)
    },
    toDate(t){
      var dt = new Date(t*1000);
      var hr = dt.getHours();
      var m = "0" + dt.getMinutes();
      var s = "0" + dt.getSeconds();
      return hr+ ':' + m.substr(-2) + ':' + s.substr(-2);  
    },

    cronometro(){
      var vm = this
      console.log(this.minutos)
       if(this.minutos>=this.MinutesLimit){
        console.log("cancelar")
        this.stopTimer()
        vm.$emit('cancelarpeticion',this.keyCiudadano)
      }
      else{
        this.CurrentDate = new Date();
        const fechaActual = this.$moment(this.CurrentDate)
        let segundos = fechaActual.diff(this.momentFechaCreacion,'seconds')
        this.minutos = Math.floor(segundos/60)
        let time = segundos - ( this.minutos*60)
        this.minutosPasados =  this.minutos + ":" + time
        }
    },

   

    verificarFecha(){
      var vm = this
     
      if(this.minutos>=this.MinutesLimit){
        vm.$emit('cancelarpeticion',this.keyCiudadano)
      }
      else{
        // this.CurrentDate = new Date();
        // this.fechaCreacion = this.hora;
        // const fechaCreacion = this.$moment( this.fechaCreacion).toDate()
        // const a = this.$moment(fechaCreacion);
        // const b = this.$moment(this.CurrentDate); // mayor
        // this.minutosPasados = b.diff(a,'minutes')
        console.log("___")
         this.minutosPasados  = ""
      }
    },

    stopTimer(){
      clearInterval(this.interval);
      console.log("clean interval of component")
    }
   
  },
  created() {
    this.minutosPasados = "calculando ..."
    this.fechaCreacion = this.hora;
    let dateFechaCreacion = this.$moment(this.fechaCreacion).toDate()
    this.momentFechaCreacion = this.$moment(dateFechaCreacion);
    /* si el status es de creado, empezar timer*/
    if(this.estatus=="0" || this.estatus=="1" ){
      this.beginsTimer(); 
    }   
    else{
      this.stopTimer()
      this.verificarFecha()
    }
  }

}
</script>
